import { useEffect } from 'react'

import { useAyuda } from '@/lib/ayuda'

/**
 * Declara el artículo de ayuda de un modal o de una pantalla con nombre
 * propio, mientras está montado.
 *
 * Se llama `useAyudaDe` y no `usarAyuda` aunque el código sea en castellano:
 * la convención del sistema (y la que entiende el linter de React) es el
 * prefijo `use` con el resto en castellano, como `useSesion` o `useSinInternet`.
 *
 * El caso normal no necesita esto: el código sale de la ruta. Hace falta
 * cuando lo que está adelante del usuario no cambió la dirección, que es lo
 * que pasa con todos los modales. El diálogo de cobro se abre encima del POS y
 * la URL sigue siendo la del POS, así que el botón de ayuda mostraría el
 * artículo de la venta cuando lo que hay adelante es el cobro.
 *
 * Al desmontarse se da de baja solo, y la ayuda vuelve a la de la pantalla que
 * quedó visible.
 */
export function useAyudaDe(codigo: string) {
  const registrar = useAyuda((s) => s.registrar)
  const quitar = useAyuda((s) => s.quitar)

  useEffect(() => {
    registrar(codigo)
    return () => quitar(codigo)
  }, [codigo, registrar, quitar])
}
